/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SmartProblemDetails,
} from '../models/index';
import {
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
} from '../models/index';

export interface CancelAudioTranscriptionPostRequest {
    processId?: string;
}

export interface TranscriptionTranscribeAudioFilePostRequest {
    processId?: string;
    fileName?: string;
    duration?: number;
    fileSizeInBytes?: number;
    audioLanguage?: string;
}

/**
 * 
 */
export class TranscriptionApi extends runtime.BaseAPI {

    /**
     */
    async cancelAudioTranscriptionPostRaw(requestParameters: CancelAudioTranscriptionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['processId'] != null) {
            headerParameters['processId'] = String(requestParameters['processId']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Transcription/CancelAudioTranscription`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async cancelAudioTranscriptionPost(requestParameters: CancelAudioTranscriptionPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.cancelAudioTranscriptionPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async transcriptionTranscribeAudioFilePostRaw(requestParameters: TranscriptionTranscribeAudioFilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['processId'] != null) {
            headerParameters['processId'] = String(requestParameters['processId']);
        }

        if (requestParameters['fileName'] != null) {
            headerParameters['fileName'] = String(requestParameters['fileName']);
        }

        if (requestParameters['duration'] != null) {
            headerParameters['duration'] = String(requestParameters['duration']);
        }

        if (requestParameters['fileSizeInBytes'] != null) {
            headerParameters['fileSizeInBytes'] = String(requestParameters['fileSizeInBytes']);
        }

        if (requestParameters['audioLanguage'] != null) {
            headerParameters['audioLanguage'] = String(requestParameters['audioLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Transcription`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async transcriptionTranscribeAudioFilePost(requestParameters: TranscriptionTranscribeAudioFilePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.transcriptionTranscribeAudioFilePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
